module.exports = __webpack_public_path__ + "img/workProjectBoard.a7694658.svg";